import React from "react";
import {observer} from "mobx-react";
import {useViewController} from "data/services/locator";
import {Bindings} from "data/constants/bindings";
import {Modal, IconButton} from "@mui/material";
import styled from "@emotion/styled";
import CloseIcon from "@mui/icons-material/Close";
import {SquadUtils} from "data/utils/squad.utils";
import {PlayerCategory} from "data/enums";
import {css} from "@mui/material/styles";
import {IModalRosterStatsController} from "views/components/modals/modal_roster_stats/modal_roster_stats.controller";
import {PlayerStatsScoring} from "views/components/players/player_stats/player_stats_scoring.component";

const Content = styled.div<{squadBackground?: string; isCold: boolean}>`
	position: fixed;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	align-items: center;
	gap: 16px;
	outline: none;
	max-width: 334px;
	width: 100%;
	background: ${(props) => props.squadBackground};
	border-radius: 20px;
	text-align: center;
	color: #ffffff;
	padding: 16px 16px 25px 16px;
	overflow: hidden;
	z-index: 1;
	${(props) =>
		props.isCold &&
		css`
			&:before {
				content: "";
				display: block;
				position: absolute;
				top: 0;
				left: 0;
				width: 100%;
				height: 100%;
				z-index: 0;
				background: linear-gradient(180deg, #bfe6fb 0%, rgba(191, 230, 251, 0) 30%);
			}
		`}
`;

const CloseBlock = styled.div`
	width: 100%;
	display: flex;
	justify-content: flex-end;
	align-items: center;

	button {
		padding: 0;

		svg {
			width: 32px;
			height: 32px;
			color: #fff;
		}
	}
`;

export const ModalRosterStats: React.FC = observer(() => {
	const {isOpen, player, onClose, contestId} = useViewController<IModalRosterStatsController>(
		Bindings.ModalRosterStatsController
	);

	return (
		<Modal open={isOpen} onClose={onClose}>
			<Content
				squadBackground={SquadUtils.buildCSSVarBackground(player, false)}
				isCold={player?.contestStats?.category === PlayerCategory.COLD}>
				<CloseBlock>
					<IconButton sx={{minWidth: 0}} onClick={onClose}>
						<CloseIcon />
					</IconButton>
				</CloseBlock>
				<PlayerStatsScoring playerId={player?.id || 0} contestId={contestId} />
			</Content>
		</Modal>
	);
});
